(function () {
  'use strict';

  const { iman, BaseCarousel } = window.Universe;


  class QuotesCarousels {
    constructor() {
      this.init();
    }

    setup() {
      for (let i = 0; i < this.DOM.sections.length; i++) {
        this.carousels.push(new QuotesCarousel(this.DOM.sections[i]));
      }
    }

    reinit() {
      this.destroy();
      this.init();
    }

    reinitSection(sectionEl) {
      this.destroySection(sectionEl);
      if (!this.DOM) { this.DOM = {}; this.carousels = []; }
      const newSections = sectionEl.querySelectorAll('.js-quotes-carousel-section');
      for (let i = 0; i < newSections.length; i++) {
        this.carousels.push(new QuotesCarousel(newSections[i]));
      }
      this.DOM.sections = document.querySelectorAll('.js-quotes-carousel-section');
    }

    destroySection(sectionEl) {
      if (!this.carousels) return;
      const targetId = sectionEl.id || sectionEl.closest('.shopify-section')?.id;
      if (!targetId) return;
      for (let i = this.carousels.length - 1; i >= 0; i--) {
        const item = this.carousels[i];
        if (item.sectionId === targetId) {
          item.destroy();
          this.carousels.splice(i, 1);
        }
      }
    }

    onBlockSelect(blockEl) {
      for (let i = 0; i < this.carousels.length; i++) {
        const item = this.carousels[i];
        if (item.DOM && item.DOM.section && item.DOM.section.contains(blockEl)) {
          const slide = blockEl.closest('.carousel__slide');
          if (!slide) break;

          const emblaApi = item.instance ? item.instance.instance : null;
          if (emblaApi) {
            const slides = emblaApi.slideNodes();
            const slideIndex = Array.from(slides).indexOf(slide);
            if (slideIndex !== -1) {
              const autoplay = emblaApi.plugins().autoplay;
              if (autoplay) autoplay.stop();
              emblaApi.scrollTo(slideIndex);
            }
          }
          break;
        }
      }
    }

    onBlockDeselect(blockEl) {
      for (let i = 0; i < this.carousels.length; i++) {
        const item = this.carousels[i];
        if (item.DOM && item.DOM.section && item.DOM.section.contains(blockEl)) {
          const emblaApi = item.instance ? item.instance.instance : null;
          if (emblaApi) {
            const autoplay = emblaApi.plugins().autoplay;
            if (autoplay) autoplay.play();
          }
          break;
        }
      }
    }

    destroy() {
      if (this.DOM) {
        for (let i = 0; i < this.carousels.length; i++) {
          this.carousels[i].destroy();
        }
        this.carousels = [];
        this.DOM = undefined;
      }
    }

    init(container) {
      if (!container) container = document;
      const sections = container.querySelectorAll('.js-quotes-carousel-section');

      if (sections.length) {
        this.DOM = {};
        this.DOM.sections = sections;

        this.carousels = [];

        this.setup();
      }
    }
  }


  class QuotesCarousel {
    constructor(section) {
      this.onPrev = () => {
        this.instance.instance.scrollPrev();
      };

      this.onNext = () => {
        this.instance.instance.scrollNext();
      };

      this.handleKeyDown = (e) => {
        if (!this.DOM.section.contains(document.activeElement)) return;

        switch (e.key) {
          case 'ArrowLeft':
            e.preventDefault();
            this.instance.instance.scrollPrev();
            break;
          case 'ArrowRight':
            e.preventDefault();
            this.instance.instance.scrollNext();
            break;
        }
      };

      if (section) {
        this.init(section);
      }
    }

    setup() {
      this.instance = new BaseCarousel({
        wrap: this.DOM.section,
        carouselOptions: {
          align: 'start',
          loop: true,
          breakpoints: {
            '(min-width: 1024px)': {
              watchDrag: false,
            },
            '(max-width: 1023px)': {
              watchDrag: true,
            },
          },
        },
        onReady: () => {
          // Announce slide changes to screen readers
          this.instance.instance.on('select', () => {
            this.announceSlideChange();
            this.updateButtonStates();
          });
          // Initial button state update
          this.updateButtonStates();

          if (this.DOM.prev.length) {
            for (let i = 0; i < this.DOM.prev.length; i++) {
              this.DOM.prev[i].addEventListener('click', this.onPrev);
            }
          }

          if (this.DOM.next.length) {
            for (let i = 0; i < this.DOM.next.length; i++) {
              this.DOM.next[i].addEventListener('click', this.onNext);
            }
          }

          // Add keyboard navigation
          if (this.DOM.viewport) {
            this.DOM.viewport.addEventListener('keydown', this.handleKeyDown);
          }
        },
      });
    }

    updateButtonStates() {
      if (!this.instance || !this.instance.instance) return;

      const canScrollPrev = this.instance.instance.canScrollPrev();
      const canScrollNext = this.instance.instance.canScrollNext();

      if (this.DOM.prev.length) {
        for (let i = 0; i < this.DOM.prev.length; i++) {
          this.DOM.prev[i].removeAttribute('disabled');
          this.DOM.prev[i].setAttribute('aria-disabled', !canScrollPrev);
        }
      }

      if (this.DOM.next.length) {
        for (let i = 0; i < this.DOM.next.length; i++) {
          this.DOM.next[i].removeAttribute('disabled');
          this.DOM.next[i].setAttribute('aria-disabled', !canScrollNext);
        }
      }
    }

    announceSlideChange() {
      if (!this.DOM.announcement || !this.instance || !this.instance.instance) return;

      const currentSlide = this.instance.instance.selectedScrollSnap() + 1;
      const totalSlides = this.instance.instance.scrollSnapList().length;
      const template = window.quotesCarouselStrings?.quoteAnnouncement || 'Showing quote [current] of [total]';
      this.DOM.announcement.textContent = template.replace('[current]', currentSlide).replace('[total]', totalSlides);
    }

    destroy() {
      if (this.DOM) {
        if (this.DOM.prev.length) {
          for (let i = 0; i < this.DOM.prev.length; i++) {
            this.DOM.prev[i].removeEventListener('click', this.onPrev);
          }
        }

        if (this.DOM.next.length) {
          for (let i = 0; i < this.DOM.next.length; i++) {
            this.DOM.next[i].removeEventListener('click', this.onNext);
          }
        }

        if (this.DOM.viewport) {
          this.DOM.viewport.removeEventListener('keydown', this.handleKeyDown);
        }

        if (this.instance) this.instance.destroy();

        this.instance = undefined;
        this.DOM = undefined;
      }
    }

    init(section) {
      this.DOM = {};
      this.DOM.section = section;
      this.sectionId = this.DOM.section.closest('.shopify-section')?.id || null;
      this.DOM.prev = this.DOM.section.querySelectorAll('.js-carousel-prev');
      this.DOM.next = this.DOM.section.querySelectorAll('.js-carousel-next');
      this.DOM.announcement = this.DOM.section.querySelector('.js-carousel-announcement');
      this.DOM.viewport = this.DOM.section.querySelector('.js-carousel');

      this.setup();
    }
  }


  function init() {
    if (!iman.get('quotesCarousels')) {
      iman.add('quotesCarousels', new QuotesCarousels());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.Universe.QuotesCarousels = QuotesCarousels;
})();
